import Component from '../core/Component'
import { CMS } from '../core/config'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'

export default class ButtonsAnimation extends Component {
	prepare() {
		if (CMS) {
			return
		}
		
		setTimeout(() => {
			this.hydrateButtons()
		}, 0)
		EventBus.on(EVENTS.DOM_CHANGE, this.handleDomChange)
		EventBus.on(EVENTS.SWUP_CONTENT_REPLACED, this.handleSwupContentReplaced)
	}

	destroy() {
		EventBus.off(EVENTS.DOM_CHANGE, this.handleDomChange)
		EventBus.off(EVENTS.SWUP_CONTENT_REPLACED, this.handleSwupContentReplaced)
	}

	handleDomChange = () => {
		this.hydrateButtons()
	}

	handleSwupContentReplaced = () => {
		this.hydrateButtons()
	}

	hydrateButtons() {
		const buttons = [...document.querySelectorAll('.Button:not(.is-ready)')]
		buttons.forEach((button) => {
			let iconName = ''

			iconName = button.getAttribute('data-iconright')
			if (iconName) {
				const span = document.createElement('span')
				span.className = `Button-iconRight Icon Icon--${iconName}`
				button.appendChild(span)
			}

			iconName = button.getAttribute('data-iconleft')
			if (iconName) {
				const span = document.createElement('span')
				span.className = `Button-iconLeft Icon Icon--${iconName}`
				button.insertBefore(span, button.firstChild)
			}

			iconName = button.getAttribute('data-icon')
			if (iconName) {
				const span = document.createElement('span')
				span.className = `Button-icon Icon Icon--${iconName}`
				button.insertBefore(span, button.firstChild)
			}

			const span = document.createElement('span')
			const span2 = document.createElement('span')
			span.innerHTML = button.innerHTML
			span2.innerHTML = button.innerHTML

			span.ariaHidden = 'true'
			span2.ariaHidden = 'true'

			button.innerHTML = `<span>${button.innerHTML}</span>`

			button.appendChild(span)
			button.appendChild(span2)
			span.setAttribute('data-hover','clone1')
			span2.setAttribute('data-hover','clone2')

			button.classList.add('is-ready')
			button.classList.add('has-animation')
		})
	}
}
